import { createSlice } from '@reduxjs/toolkit'

// Setup the initial state

const initialState = {
  generate: {},
  validate: {},
};

export const otpSlice = createSlice({
  name: 'otp',
  initialState,
  reducers: {
    
    // Generate OTP Code

    setGenerateOtpLoading: (state) => {
      state.generate = {
        isLoading: true,
      };
    },
    setGenerateOtpScuccess: (state, action) => {
      state.generate = {
        otpSent: true,
      };
    },
    setGenerateOtpFailure: (state, action) => {
      state.generate = {
        error: action.payload,
      }
    },

    
    // Validate OTP Code

    setValidateOtpLoading: (state) => {
      state.validate = {
        isLoading: true,
      };
    },
    setValidateOtpScuccess: (state, action) => {
      state.validate = {
        otpValid: true,
        data: action.payload,
      };
    },
    setValidateOtpFailure: (state, action) => {
      state.validate = {
        error: action.payload,
      }
    },


    // Reset Otp State

    resetOtpState: () => initialState,
  },
})

export const { 
  setGenerateOtpLoading, setGenerateOtpScuccess, setGenerateOtpFailure,
  setValidateOtpLoading, setValidateOtpScuccess, setValidateOtpFailure,
  resetOtpState,
} = otpSlice.actions

export default otpSlice.reducer;